import api from "./api";

// Catálogo de setores/equipes — gestor/admin gerencia; alimenta o dropdown do
// cadastro de usuário e o agrupamento da Produtividade.
export interface Setor {
  id: string;
  nome: string;
  cor: string;
  ordem: number;
  ativo: boolean;
}

export async function listarSetores(opts?: { todos?: boolean }) {
  const r = await api.get(`/setores${opts?.todos ? "?todos=1" : ""}`);
  return r.data.data as Setor[];
}

export async function criarSetor(dados: { nome: string; cor?: string; ordem?: number }) {
  const r = await api.post("/setores", dados);
  return r.data.data as Setor;
}

export async function atualizarSetor(id: string, dados: Partial<{ nome: string; cor: string; ativo: boolean; ordem: number }>) {
  const r = await api.patch(`/setores/${id}`, dados);
  return r.data.data as Setor;
}

export async function excluirSetor(id: string) {
  await api.delete(`/setores/${id}`);
}
